require('intersection-observer'); //polyfill

export default class LazyLoader {

  constructor () {

    let imageNodes = [].slice.call(document.querySelectorAll('[data-lazy-src]'));
    const intersectionObserver = new IntersectionObserver(
      this.onIntersectionObservation,
      { rootMargin: '0px 0px 100px 0px' } // preload all images that are in the viewport and 100px below "the fold".
    );
    imageNodes.forEach( ( imageNode ) => intersectionObserver.observe( imageNode ) );

  }

  onIntersectionObservation( entries, observer ) {
    entries.filter(  ( entry ) => entry.target.hasAttribute( 'data-lazy-src' ) && entry.isIntersecting )
    .forEach( ( entry ) => {
      $(entry.target).css({
        'filter': 'blur(15px)',
        'transition': 'all s ease-in',
      });

      let image = new Image();
      image.src = entry.target.getAttribute( 'data-lazy-src' );

      $(image).on('load', function() {
        if( entry.target.getAttribute('data-background') ) {
          $(entry.target).css({
            'backgroundImage': `url( ${image.src} )`,
          });
        } else {
          entry.target.setAttribute( 'src', image.src );
          entry.target.removeAttribute( 'data-lazy-src' );

          if( entry.target.getAttribute('data-srcset') &&     entry.target.getAttribute('data-sizes') ) {
            entry.target.setAttribute( 'srcset', entry.target.getAttribute('data-srcset') );
            entry.target.setAttribute( 'sizes', entry.target.getAttribute('data-sizes') );
          }
        }

        $(entry.target).css({
          'filter': 'none',
        });
      });
      // swap data-src and src
      observer.unobserve( entry.target );
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/modules/lazy-loader.js